module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1296.27e33d84.png";